<template>
  <div fluid :class="$vuetify.breakpoint.mdAndUp ? 'px-5' : 'px-3'">
    <v-form :v-model="true">
      <v-col cols="12" class="px-3 mb-2">
        <v-row>
          <v-col cols="12" md="7">
            <v-autocomplete v-model="dNewStatus"
                            :label="$t('compDetails.newStatus')+'*'" 
                            :items="dStatusArray" 
                            item-value="newStatus" 
                            item-text="label"  
                            hide-details
                            item-color="datPrimary" 
                            color="datPrimary"  
                            class="mt-0"/>
          </v-col>
          <v-col v-if="dNewStatus === 'RECHAZADA'" cols="12">
            <v-textarea v-model="dDescription"  
                        auto-grow 
                        :id="('dDescription')" 
                        :label="$t('datGeneric.description')+'*'"
                        item-color="datPrimary" 
                        color="datPrimary" 
                        class="mt-0" 
                        rows="2" />
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-btn depressed class="datPrimaryBtn ma-3" @click="fSetComplaintStatus">
            {{$t('datBtn.save')}}
          </v-btn>
          <v-btn depressed class="datPrimaryBtn ma-3" @click="fClose">
            {{$t('btn.backTo')}}
          </v-btn>
        </v-row>
      </v-col>
    </v-form>
  </div>
</template>

<script>
import ServiceEcomplaints from '@/services/srv-eComplaints'

export default {

  mounted(){
    this.dComplaintInfo = this.pComplaintInfo
    this.fFillsStatusList()
  },

  data () {
    return {
      dDescription: '',
      dComplaintInfo: {},
      dStatusArray: [],
      dNewStatus: null,
      // rules: {
      //   required: value => !!value || this.$t('datError.fillAllData') , //this.fSnackbarError(this.$t('datError.fillAllData'), this.pShowSnackbar),
      // },
    }
  },

  props:{
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },  
    pComplaintInfo:{
      type: Object,
      required: true
    }
  },

  methods: {
    // Comprueba que los campos se han rellenado correctamente
    fCheckDescription(){
      if(this.dDescription == null || this.dDescription.trim() === '') {
        this.fThrowError(this.$t('datError.fillAllData'), this.pShowSnackbar)
      }
    },

    fLimitDays(item){
      const endDate = new Date(item.limitDate)

      const iniDate = new Date()
      iniDate.setHours(0,0,0,0)

      // Calculate the difference in milliseconds
      const diffDays = endDate - iniDate 

      // Convert back to days and return
      return Math.floor(diffDays / (1000 * 60 * 60 * 24))
    },

    // Rellena la lista de posibles estados en función de la denuncia 
    fFillsStatusList(){
      this.dStatusArray = []
      const status = this.dComplaintInfo.status

      if (status === 'NUEVA'){
        this.dStatusArray.push({newStatus: 'ACEPTADA', label: this.$t('datBtn.accept')})
      } 
      
      if ((status === 'ACEPTADA' || status === 'REABIERTA') && this.dComplaintInfo.preliminarYn === 'S'){
        this.dStatusArray.push({newStatus: 'TRAMITE_FP', label: this.$t('datBtn.startPreliminar')})
      } 
      
      if (status === 'ACEPTADA' || status === 'REABIERTA'){
        this.dStatusArray.push({newStatus: 'TRAMITE', label: this.$t('datBtn.startExp')})
      } 
      
      if (status.includes('TRAMITE')){
        this.dStatusArray.push({newStatus: 'RESUELTA', label: this.$t('datBtn.solve')})
      } 
      
      if ((status === 'RESUELTA' || status === 'RECHAZADA') && this.fLimitDays(this.dComplaintInfo) > 0){
        this.dStatusArray.push({newStatus: 'REABIERTA', label: this.$t('datBtn.reopen')})
      }  
      
      if (status !== 'RECHAZADA'){
        this.dStatusArray.push({newStatus: 'RECHAZADA', label: this.$t('datBtn.reject')})
      }

      this.dNewStatus = this.dStatusArray[0].newStatus
    },

    // Establece el estado de una denuncia
    fSetComplaintStatus(){
      if(this.dNewStatus === 'RECHAZADA'){
        this.fCheckDescription() 
      }

      const payload = {
        newStatus: this.dNewStatus,
        anulReason: this.dDescription,
        complaintId: this.dComplaintInfo.complaintId,
        anonymousYn: this.dComplaintInfo.anonymousYn
      }

      ServiceEcomplaints.setComplaintStatus(payload).then(() => {
        this.$emit('close', true)
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      })
    },    

    // Cierra el componente de logs
    fClose(){
      this.$emit('close')
    }
  },

  watch:{
    pComplaintInfo(){
      this.dComplaintInfo = this.pComplaintInfo
      this.fFillsStatusList()
    }
  }
}
</script>

 